import { useQuery } from "@tanstack/react-query";
import { fetchLeaks } from "@/utils/dashboardFetch";
import { LeakItem } from "@/types/dashboard"; // Assuming type exists, if not will default to any

export const useLeaksQuery = () => {
    return useQuery({
        queryKey: ['leaks'],
        queryFn: fetchLeaks,
        staleTime: 1000 * 60 * 15, // 15 minutes
    });
};
